import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { WorkspaceTag } from "@msuite/ui/tag";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoiceListItem } from "@msuite/utils/types";
import {
	formatInvoiceAmount,
	formatInvoiceDate,
	IncomingInvoiceKindLabel,
	IncomingInvoiceStateTag,
} from "@/components/incoming-invoices";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<IncomingInvoiceListItem>();

export const columns = [
	columnHelper.accessor("number", {
		id: "number",
		header: localized("incoming_invoices.number"),
		cell: (cell) => guardString(cell.getValue()),
		size: 180,
	}),
	columnHelper.accessor("issuerName", {
		id: "issuerName",
		header: localized("incoming_invoices.supplier"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor((row) => row.workspace?.name ?? null, {
		id: "workspace",
		header: localized("organization.workspace"),
		cell: (cell) => <WorkspaceTag workspace={cell.row.original.workspace ?? undefined} />,
		size: 150,
	}),
	columnHelper.accessor("kind", {
		id: "kind",
		header: localized("incoming_invoices.kind_label"),
		cell: (cell) => <IncomingInvoiceKindLabel kind={cell.getValue()} />,
		size: 160,
	}),
	columnHelper.accessor("invoiceDate", {
		id: "invoiceDate",
		header: localized("incoming_invoices.invoice_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 140,
	}),
	columnHelper.accessor("dueDate", {
		id: "dueDate",
		header: localized("incoming_invoices.due_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 140,
	}),
	columnHelper.accessor("netAmount", {
		id: "netAmount",
		header: localized("incoming_invoices.net_amount"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), cell.row.original.currency),
		size: 140,
	}),
	columnHelper.accessor("grossAmount", {
		id: "grossAmount",
		header: localized("incoming_invoices.gross_amount"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), cell.row.original.currency),
		size: 140,
	}),
	columnHelper.accessor("state", {
		id: "state",
		header: localized("general.state"),
		cell: (cell) => <IncomingInvoiceStateTag state={cell.getValue()} />,
		size: 130,
	}),
	createRowActions(RowActions),
];
